/* assets/recently-viewed.js — server-render を使わない安定版 */
(function () {
  'use strict';

  const KEY  = 'rv_handles_v1';
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  // ---- 履歴の取得（除外 & 上限）
  function getHistory(exclude, limit){
    try{
      let arr = JSON.parse(localStorage.getItem(KEY)) || [];
      if (exclude) arr = arr.filter(h => h !== exclude);
      return arr.slice(0, limit);
    }catch(e){ return []; }
  }

  // ---- 一度だけ実行（遅延）
  function onceInView(el, cb){
    if (!('IntersectionObserver' in window)) { cb(); return; }
    const io = new IntersectionObserver(es => {
      if (es.some(e => e.isIntersecting)){ io.disconnect(); cb(); }
    }, { rootMargin: '200px' });
    io.observe(el);
  }

  // ---- ユーティリティ
  const getLocale = (root) => root.dataset.locale || document.documentElement.lang || navigator.language || 'ja-JP';
  const getCurrency = (root) => {
    return root.dataset.currency ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      'JPY';
  };

  const getCardSettings = (root) => ({
    style: root.dataset.cardStyle || 'standard',
    colorScheme: root.dataset.cardColorScheme || 'scheme-1',
    textAlignment: root.dataset.cardTextAlignment || 'left',
    badgePosition: root.dataset.badgePosition || 'bottom left',
    saleBadgeColorScheme: root.dataset.saleBadgeColorScheme || 'scheme-4',
    soldOutBadgeColorScheme: root.dataset.soldOutBadgeColorScheme || 'scheme-3',
    onSaleLabel: root.dataset.onSaleLabel || 'Sale',
    soldOutLabel: root.dataset.soldOutLabel || 'Sold out'
  });

  const fmtMoney = (cents, locale, currency) => {
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol'
      }).format(cents / 100);
    } catch (e) {
      return Math.round(cents / 100).toLocaleString(locale);
    }
  };

  const validPrice = (value) => {
    if (typeof value === 'boolean' || value === null || value === undefined) return null;
    if (typeof value === 'string') {
      const normalized = value.trim();
      if (!/^(?:\d+\.?\d*|\.\d+)$/.test(normalized)) return null;
      value = normalized;
    }
    const price = Number(value);
    return Number.isFinite(price) && price >= 0 ? price : null;
  };

  const selectPriceVariant = (p) => {
    if (!Array.isArray(p.variants)) {
      const price = validPrice(p.price);
      if (price === null) return null;
      return {
        price,
        compareAtPrice: validPrice(p.compare_at_price) || 0,
        available: p.available !== false
      };
    }

    const hasAvailableVariant = p.variants.some(variant => variant.available === true);
    const candidates = hasAvailableVariant
      ? p.variants.filter(variant => variant.available === true)
      : p.variants;
    let selected = null;
    let selectedPrice = null;

    candidates.forEach(variant => {
      const price = validPrice(variant.price);
      if (price === null) return;
      if (selected === null || price < selectedPrice) {
        selected = variant;
        selectedPrice = price;
      }
    });

    if (!selected) return null;
    return {
      price: selectedPrice,
      compareAtPrice: validPrice(selected.compare_at_price) || 0,
      available: hasAvailableVariant
    };
  };

  // 画像 URL（幅指定版を生成）
  function imgUrl(p, width = 700){
    let raw = p.featured_image || (p.images && (typeof p.images[0]==='string'
               ? p.images[0]
               : (p.images[0] && (p.images[0].src || p.images[0].url))));
    if (!raw) return '';
    if (raw.indexOf('//') === 0) raw = location.protocol + raw;
    const m = raw.match(/^(.*\/[^\/]+?)(\.(?:jpe?g|png|webp|gif))(?:\?.*)?$/i);
    if (!m) return raw;
    return `${m[1]}_${width}x${m[2]}`;
  }

  function appendClasses(el, classes) {
    classes.filter(Boolean).forEach(className => el.classList.add(...className.split(' ').filter(Boolean)));
  }

  function buildPrice(price, compareAtPrice, available, locale, currency) {
    const priceRoot = document.createElement('div');
    const container = document.createElement('div');
    const regular = document.createElement('div');
    const sale = document.createElement('div');
    const regularItem = document.createElement('span');
    const saleRegularItem = document.createElement('span');
    const saleItem = document.createElement('span');

    priceRoot.className = 'price';
    if (!available) priceRoot.classList.add('price--sold-out');
    if (compareAtPrice > price) priceRoot.classList.add('price--on-sale');

    container.className = 'price__container';
    regular.className = 'price__regular';
    sale.className = 'price__sale';
    regularItem.className = 'price-item price-item--regular';
    saleRegularItem.className = 'price-item price-item--regular';
    saleItem.className = 'price-item price-item--sale price-item--last';

    regularItem.textContent = fmtMoney(price, locale, currency);
    saleRegularItem.textContent = compareAtPrice > price ? fmtMoney(compareAtPrice, locale, currency) : '';
    saleItem.textContent = fmtMoney(price, locale, currency);

    regular.appendChild(regularItem);
    sale.append(saleRegularItem, saleItem);
    container.append(regular, sale);
    priceRoot.appendChild(container);
    return priceRoot;
  }

  function buildBadge(available, price, compareAtPrice, settings) {
    const badge = document.createElement('div');
    const badgePosition = settings.badgePosition.split(' ').filter(Boolean);
    badge.className = 'card__badge';
    appendClasses(badge, badgePosition);

    if (!available) {
      const soldOut = document.createElement('span');
      soldOut.className = `badge badge--bottom-left color-${settings.soldOutBadgeColorScheme}`;
      soldOut.textContent = settings.soldOutLabel;
      badge.appendChild(soldOut);
    } else if (compareAtPrice > price) {
      const onSale = document.createElement('span');
      onSale.className = `badge badge--bottom-left color-${settings.saleBadgeColorScheme}`;
      onSale.textContent = settings.onSaleLabel;
      badge.appendChild(onSale);
    }

    return badge;
  }

  function buildCard(p, locale, currency, settings){
    const title = p.title || '';
    const selectedPrice = selectPriceVariant(p);
    if (!selectedPrice) return null;
    const { price, compareAtPrice, available } = selectedPrice;
    const image = imgUrl(p, 700);
    const item = document.createElement('li');
    const wrapper = document.createElement('div');
    const card = document.createElement('div');
    const inner = document.createElement('div');
    const innerContent = document.createElement('div');
    const mediaWrapper = document.createElement('div');
    const media = document.createElement('div');
    const outerContent = document.createElement('div');
    const information = document.createElement('div');
    const heading = document.createElement('h3');
    const link = document.createElement('a');
    const cardInformation = document.createElement('div');
    const priceEl = buildPrice(price, compareAtPrice, available, locale, currency);
    const innerBadge = buildBadge(available, price, compareAtPrice, settings);
    const outerBadge = buildBadge(available, price, compareAtPrice, settings);
    const href = `${ROOT}products/${encodeURIComponent(p.handle)}`;

    item.className = 'grid__item';
    wrapper.className = 'card-wrapper product-card-wrapper underline-links-hover';
    card.className = `card card--${settings.style} ${image ? 'card--media' : 'card--text'}`;
    if (settings.style === 'card') appendClasses(card, [`color-${settings.colorScheme}`, 'gradient']);
    card.style.setProperty('--ratio-percent', '100%');
    inner.className = 'card__inner ratio';
    if (settings.style === 'standard') appendClasses(inner, [`color-${settings.colorScheme}`, 'gradient']);
    inner.style.setProperty('--ratio-percent', '100%');
    innerContent.className = 'card__content';
    innerContent.setAttribute('aria-hidden', 'true');
    mediaWrapper.className = 'card__media';
    media.className = 'media media--transparent media--hover-effect';
    outerContent.className = 'card__content';
    information.className = 'card__information';
    heading.className = image || settings.style === 'standard' ? 'card__heading h5' : 'card__heading';
    cardInformation.className = 'card-information';
    link.className = 'full-unstyled-link';
    link.href = href;
    link.textContent = title;

    if (image) {
      const img = document.createElement('img');
      img.loading = 'lazy';
      img.decoding = 'async';
      img.src = image;
      img.alt = title;
      img.className = 'motion-reduce';
      media.appendChild(img);
      mediaWrapper.appendChild(media);
      inner.appendChild(mediaWrapper);
    }

    innerContent.appendChild(innerBadge);
    inner.appendChild(innerContent);
    heading.appendChild(link);
    cardInformation.appendChild(priceEl);
    information.append(heading, cardInformation);
    outerContent.append(information, outerBadge);
    card.append(inner, outerContent);
    wrapper.appendChild(card);
    item.appendChild(wrapper);
    return item;
  }

  // ハンドル順を維持して取得
  async function loadProducts(handles){
    const arr = await Promise.all(handles.map(async h => {
      try{
        const r = await fetch(`${ROOT}products/${encodeURIComponent(h)}.js`,
                              { credentials:'same-origin' });
        if (!r.ok) return null;
        return await r.json();
      }catch(_e){ return null; }
    }));
    return arr.filter(Boolean);
  }

  // ---- 起動
  function initRecentlyViewed(scope = document) {
    const roots = scope.matches?.('[data-rv-root]') ? [scope] : scope.querySelectorAll('[data-rv-root]');
    roots.forEach(root => {
      if (root.dataset.rvInitialized === 'true') return;
      root.dataset.rvInitialized = 'true';

      const limit    = parseInt(root.dataset.limit || '8', 10);
      const exclude  = root.dataset.exclude || null;
      const locale   = getLocale(root);
      const currency = getCurrency(root);
      const cardSettings = getCardSettings(root);
      const grid     = root.querySelector('[data-rv-grid]');
      const clearBtn = root.querySelector('.rv-clear');

      onceInView(root, async () => {
        const handles = getHistory(exclude, limit);
        if (!handles.length){ root.style.display = 'none'; return; }

        const products = await loadProducts(handles);
        if (!products.length){ root.style.display = 'none'; return; }

        const fragment = document.createDocumentFragment();
        let renderedCardCount = 0;
        products.forEach(product => {
          const card = buildCard(product, locale, currency, cardSettings);
          if (card) {
            fragment.appendChild(card);
            renderedCardCount += 1;
          }
        });
        if (renderedCardCount === 0) { root.style.display = 'none'; return; }
        grid.replaceChildren(fragment);

        if (clearBtn){
          clearBtn.hidden = false;
          clearBtn.addEventListener('click', () => {
            localStorage.removeItem(KEY);
            root.remove();
          });
        }
      });
    });
  }

  window.initMoriRecentlyViewed = initRecentlyViewed;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRecentlyViewed(), { once: true });
  } else {
    initRecentlyViewed();
  }

  document.addEventListener('shopify:section:load', (event) => initRecentlyViewed(event.target));
})();
